import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  createRollingArrangement,
  fetchUserRollingArrangements,
} from '../../actions/rollingArrangements';
import RollingArrangementForm from '../../components/RollingArrangementForm';
import userPage from '../../decorators/userPage';
import withPurchaseMethods from '../../decorators/withPurchaseMethods';
import { getSubmitStatus, getUserRollingArrangements } from '../../reducers';
import Spinner from 'components/Spinner';
import RollingArrangement from 'components/RollingArrangement/RollingArrangement';

class UserRollingArrangement extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    this.fetchUserRollingArrangements();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userId !== this.props.userId) {
      this.fetchUserRollingArrangements();
    }
  }

  fetchUserRollingArrangements() {
    const { userId, fetchUserRollingArrangements } = this.props;
    this.setState({ loading: true });
    fetchUserRollingArrangements(userId).finally(() =>
      this.setState({ loading: false }),
    );
  }

  onSubmit = (...params) => {
    const { createRollingArrangement } = this.props;
    this.setState({ loading: true });
    return createRollingArrangement(...params).then(() => {
      this.fetchUserRollingArrangements();
    });
  };

  render() {
    const { userRollingArrangements, paymentMethods, userId, saveStatus } =
      this.props;
    const { loading } = this.state;

    if (loading) {
      return (
        <div style={{ marginTop: '170px' }}>
          <Spinner showLoader={loading} />
        </div>
      );
    }

    if (userRollingArrangements && userRollingArrangements.length) {
      return (
        <div>
          <h1>Rolling Payment Arrangement</h1>
          <p className="links">
            <Link to={`/users/${userRollingArrangements[0].user_profile}/view`}>
              &larr; Back to User
            </Link>
          </p>
          <br />
          <RollingArrangement rollingArrangement={userRollingArrangements[0]} />
          <Link
            to={`/users/${userRollingArrangements[0].user_profile}/rolling-payments/${userRollingArrangements[0].id}/edit`}
          >
            <button className="btn btn-default">
              Edit Rolling Arrangement
            </button>
          </Link>
        </div>
      );
    }

    return (
      <div>
        <h2>Create Rolling Arrangement</h2>
        <RollingArrangementForm
          paymentMethods={paymentMethods}
          saveStatus={saveStatus}
          initialValues={{ user_profile: userId, enabled: false }}
          onSubmit={this.onSubmit}
          btnText="Create Rolling Arrangement"
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  saveStatus: getSubmitStatus(state, 'rollingArrangement'),
  userRollingArrangements: getUserRollingArrangements(state),
});

const mapDispatchToProps = {
  createRollingArrangement,
  fetchUserRollingArrangements,
};

export default compose(
  userPage,
  withPurchaseMethods,
  connect(mapStateToProps, mapDispatchToProps),
)(UserRollingArrangement);
